import { render, staticRenderFns } from "./FactorBlock.vue?vue&type=template&id=4dba7c21&scoped=true"
import script from "./FactorBlock.vue?vue&type=script&lang=ts"
export * from "./FactorBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba7c21",
  null
  
)

export default component.exports